export default {
  img: {
    height: '200px',
    width: '200px',
    margin: '10px 0'
  },
  buttons: {
    display: 'flex',
    '& > *': {
      margin: '0 8px'
    }
  }
}
